import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const BloodIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" {...rest}>
      <g
        id="Symbols-Blood"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Blood" stroke={color} strokeWidth="3">
          <g id="Group" transform="translate(10.374000, 1.729000)">
            <path d="M16.4469396,0.503723611 C16.2586504,0.190896833 15.9229046,0 15.561,0 C15.1990954,0 14.8633496,0.190896833 14.6750604,0.503723611 C11.3782032,5.97223506 0,25.2737284 0,32.661679 C0,41.3603411 6.96689701,48.412 15.561,48.412 C24.155103,48.412 31.122,41.3603411 31.122,32.661679 C31.122,25.2737284 19.7437968,5.97013502 16.4469396,0.503723611 Z" />
            <path d="M15.561,42.0467703 C13.094427,42.0534972 10.7254401,41.0720264 8.9714352,39.3167146" />
          </g>
        </g>
      </g>
    </svg>
  );
};
